import { render, staticRenderFns } from "./com-community-list.vue?vue&type=template&id=13e13af0&scoped=true&"
import script from "./com-community-list.vue?vue&type=script&lang=js&"
export * from "./com-community-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e13af0",
  null
  
)

export default component.exports